import { authGetters, authMapGetters } from '@common/store/modules';

import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

import {
  mapActions as reviewMapActions,
  mapGetters as reviewMapGetters,
} from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';

import {
  mapActions as quotationMapActions,
  mapGetters as quotationMapGetters,
} from '@/common/store/modules/estimate';
import * as quotationTypes from '@common/store/modules/estimate/types';

import { mapActions as chatMapActions } from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';

import * as commonActions from '@common/store/modules/common/types';
import { mapActions as commonMapActions } from '@common/store/modules/common';

import DesignPopup from '@/common/components/modal/DesignPopup.vue';
import Reviews from '../components/Reviews.vue';
import SortModal from '../modal/SortModal';

import InfiniteLoading from 'vue-infinite-loading';

export default {
  components: {
    DesignPopup,
    Reviews,
    SortModal,
    InfiniteLoading,
  },
  data() {
    return {
      option: {
        readOnly: false,
      },
      isReviewWrite: false,
      chatRoomType: 'OneOnOne',
      selectedFilter: 'ALL',
      filterTypes: [
        { label: '전체', value: 'ALL' },
        { label: '인터넷상담', value: 'INTERNET' },
        { label: '휴대폰상담', value: 'MOBILE' },
        { label: '매장방문', value: 'VISIT' },
        { label: '일반상담', value: 'NORMAL' },
      ],
      isSortOpen: false,
      selectedSort: { label: '최신 순', value: 'CREATED_AT_DESC' },
      sorts: [
        { label: '최신 순', value: 'CREATED_AT_DESC' },
        { label: '오래된 순', value: 'CREATED_AT_ASC' },
        { label: '별점 높은 순', value: 'RATING_DESC' },
        { label: '별점 낮은 순', value: 'RATING_ASC' },
        { label: '좋아요 많은 순', value: 'LIKE_DESC' },
        { label: '싫어요 많은 순', value: 'HATE_DESC' },
      ],
      reviewType: this.$route.query.type || '',
      shopId: this.$route.params.id,
      imageFiles: [],
      direction: 'top',
      infiniteId: 0,
      reviewPage: 1,
      reviewSize: 10,
      reviewList: [],
      score: {},
      reviewTypes: [
        { label: '인터넷', rate: 0, cnt: 0 },
        { label: '휴대폰', rate: 0, cnt: 0 },
        { label: '매장방문', rate: 0, cnt: 0 },
        { label: '일반상담', rate: 0, cnt: 0 },
      ],
      isBuyer: 'N',
      isSearchPage: false,
      searchText: '',
      reviewTotal: 0,
    };
  },
  computed: {
    commentValid() {
      return this.review.comment.length > 0 ? true : false;
    },
    ...reviewMapGetters({
      reviews: reviewTypes.REVIEWS,
    }),
    ...authMapGetters({
      curUser: authGetters.CURRENT_USER,
    }),
    ...shopMapGetters({
      shop: shopTypes.SHOP,
    }),
    ...quotationMapGetters({
      quotationList: quotationTypes.QUOTATION_LIST,
    }),
  },
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch();
    });
  },
  async mounted() {
    // 리뷰 리스트 가져오기
    this.infiniteId += 1;
  },
  beforeDestroy() {
    this[commonActions.SET_CUSTOM_HEADER_TEXT](undefined);
  },
  watch: {
    '$route.query.keyword'(val) {
      this.searchText = val;
      if (val) {
        this.isSearchPage = true;
        this.getListPageOne();
      }
    },
  },
  methods: {
    ...commonMapActions([commonActions.SET_CUSTOM_HEADER_TEXT]),
    ...shopMapActions([shopTypes.FETCH_SHOP]),
    ...reviewMapActions([
      reviewTypes.FETCH_REVIEWS,
      reviewTypes.CREATE_REVIEW,
      reviewTypes.FETCH_REVIEW_CHECK,
      reviewTypes.FETCH_REVIEW_SCORE,
    ]),
    ...quotationMapActions([quotationTypes.FETCH_QUOTATION_ME]),
    ...chatMapActions([chatActions.FETCH_CHATROOM_WITH_MEMBER]),

    async fetch() {
      if (this.$route.path.indexOf('/search') > -1) {
        this.isSearchPage = true;
        this.searchText = this.$route.query.keyword;
      }
      if (!this.isSearchPage) {
        await this.setTitle();

        // 나의 견적 리스트
        await this[quotationTypes.FETCH_QUOTATION_ME]();

        // 리뷰 스코어
        await this.getReviewScore();

        // 후기 등록 여부: reviewed => 1: 등록, 0: 미등록
        // 채팅한 기록이 있어야 리뷰 등록 가능: chat
        await this.reviewCheck();
      }
    },
    async setTitle() {
      let title = '';
      this[shopTypes.FETCH_SHOP]({ id: this.shopId }).then(() => {
        title = this.shop.name;
        this[commonActions.SET_CUSTOM_HEADER_TEXT](title);
      });
    },
    async getListPageOne() {
      this.direction = 'top';
      this.reviewPage = 1;
      this.infiniteId += 1;
    },
    async getReviewList() {
      let params = {
        page: this.reviewPage,
        size: this.reviewSize,
        // visible: true,
        del: false,
        orderType: this.selectedSort.value,
        reviewType: this.selectedFilter,
        buyer: this.isBuyer,
      };
      if (this.shopId) params.storeId = this.shopId;
      // 검색어 추가
      if (this.searchText) params.searchText = this.searchText;

      if (this.selectedFilter === 'ALL') delete params.reviewType;
      await this[reviewTypes.FETCH_REVIEWS](params).then(res => {
        this.reviewTotal = res.pagination.totalElements;
      });
    },
    async infiniteHandler($state) {
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.getReviewList();

        if (this.reviewPage == 1) {
          this.reviewList = [];
        }
        if (this.reviews.data.length) {
          await this.reviewList.push(...this.reviews.data);
          if (this.reviewPage == 1) {
            setTimeout(() => {
              // this.$refs.dummy.scrollIntoView({ behavior: 'auto' });
            }, 10);
          }
          this.reviewPage += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    deleteReview() {
      this.getListPageOne();
      this.reviewCheck();
    },
    async reviewCheck() {
      const params = { storeId: this.shopId };
      const checkReview = await this[reviewTypes.FETCH_REVIEW_CHECK](params);
      // reviewed: 해당 매장에 내가 작성한 리뷰 갯수
      // chat: 매장과의 채팅 여부
      if (checkReview.reviewed === 0 && checkReview.chat > 0) {
        this.isReviewWrite = true;
      }
    },
    write() {
      this.$router.push({
        name: 'Shops.WriteReview',
        params: { id: this.shop.id },
        query: { type: this.$route.query.type },
      });
    },
    selectSort() {
      this.isSortOpen = true;
    },
    async sortModalClose(val) {
      if (val) {
        this.sorts.find(item => {
          if (item === val) {
            this.selectedSort = val;
          }
        });
        this.getListPageOne();
      }
      this.isSortOpen = false;
    },
    async selectFilter(val) {
      this.selectedFilter = val;
      this.getListPageOne();
    },
    async getReviewScore() {
      this[reviewTypes.FETCH_REVIEW_SCORE](this.shopId).then(res => {
        this.score = res;
        let result = [];
        result.push({
          label: '인터넷',
          rate: this.score.internetScore,
          cnt: this.score.internetReviewCnt,
        });
        result.push({
          label: '휴대폰',
          rate: this.score.mobileScore,
          cnt: this.score.mobileReviewCnt,
        });
        result.push({
          label: '매장방문',
          rate: this.score.visitScore,
          cnt: this.score.visitReviewCnt,
        });
        result.push({
          label: '일반상담',
          rate: this.score.normalScore,
          cnt: this.score.normalReviewCnt,
        });
        this.reviewTypes = result;
      });
    },
    saveKeyword() {
      if (!this.searchText.trim()) return;

      const recentWords =
        JSON.parse(localStorage.getItem('recent-keywords')) || [];

      recentWords.forEach((item, idx) => {
        if (item == this.searchText.trim()) recentWords.splice(idx, 1);
      });

      recentWords.unshift(this.searchText.trim());
      if (recentWords.length > 3) recentWords.splice(3);
      localStorage.setItem('recent-keywords', JSON.stringify(recentWords));

      this.$router
        .push({
          name: 'Search.Reviews',
          query: { keyword: this.searchText },
        })
        .catch(() => {});
    },
  },
};
